export enum PitchingProgressState {
  StartPitching,
  WaitingForAPitch,
  PitchRegistered,
  TryAgain,
  EnoughPitches,
}
